import { Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import AdminModule from "./AdminModule";
import Signin from "./components/SignIn";
import SubscriberModule from "./SubscriberModule";
import StripePage from "./pages/StripePage";
import StripePageFree from "./pages/StripePageFree";
import Error404 from "./pages/Error404";
import GoToTop from "./components/global/PageTop";
import SuccessPage from "./pages/SuccessPage";
import ResetPassword from "./components/ResetPassword";
import SignUp from "./components/SignUp";

function App() {
  // Override the ResizeObserver error
  const resizeObserverLoopErr = () => {
    const errMsg = "ResizeObserver loop limit exceeded";
    if (typeof ErrorEvent !== "undefined") {
      window.addEventListener("error", (event) => {
        if (event.message === errMsg) {
          event.stopImmediatePropagation();
        }
      });
    }
  };

  resizeObserverLoopErr();

  return (
    <>
      <GoToTop />
      <Routes>
        <Route path="/signin" element={<Signin />} />
        <Route path="/forget-password" element={<ResetPassword />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/stripe/product1" element={<StripePage />} />
        <Route path="stripe/product0" element={<StripePageFree />} />
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin/*" element={<AdminModule />} />
        <Route path="/subscriber/*" element={<SubscriberModule />} />
        <Route path="/stripe/success" element={<SuccessPage />} />
        <Route path="*" element={<Error404 />} />
      </Routes>
    </>
  );
}
export default App;
